///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.thoughtspot = abcsetup.thoughtspot || {};
abcsetup.thoughtspot.sponsorships = abcsetup.thoughtspot.sponsorships || {};
abcsetup.thoughtspot.sponsorships.ordering = abcsetup.thoughtspot.sponsorships.ordering || {};
abcsetup.thoughtspot.sponsorships.ordering.show = abcsetup.thoughtspot.sponsorships.ordering.show || {};


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.thoughtspot.sponsorships.ordering.show = {
    init() {
        abcsetup.setTitle('Sponsorship Ordering');

        $('.sortable_sponsorships')
            .toArray()
            .forEach(list => Sortable.create(list));
    }
}
